import { CacheProvider } from '@emotion/react';
import { ReactNode } from 'react';
import createEmotionCache from './create-emotion-cache';
import { ThemeProvider as OgThemeProvider, Theme, CssBaseline } from './index';

interface ThemeProviderProps {
    children: ReactNode;
    theme: Theme;
}

const clientSideEmotionCache = createEmotionCache();

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => (
    <CacheProvider value={clientSideEmotionCache}>
        <OgThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </OgThemeProvider>
    </CacheProvider>
);

export default ThemeProvider;
